import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSearchContext } from '../../contexts/SearchContext';
import { useFacets } from '../../contexts/FacetsContext';
import { extractFacetsFromSearchResults } from '../../utils/facets/facets-shared';

/**
 * Extracts facets from search results and updates FacetsContext.
 * Skips overwriting when we are still showing SSR/initial results so that
 * desktop category pills stay 100% aligned with the server-rendered static shell.
 */
export const FacetsUpdater = () => {
  const { results, initialResults, filters } = useSearchContext();
  const { setFacetsData } = useFacets();
  const intl = useIntl();
  const locale = intl.locale;

  useEffect(() => {
    if (!results?.facets) return;
    // Keep server-passed facets until user triggers a new search (different results)
    if (initialResults != null && results === initialResults) {
      return;
    }
    const filtersObj =
      typeof filters === 'object' && filters ? (filters as Record<string, string[]>) : {};
    const facetsData = extractFacetsFromSearchResults(results, filtersObj, locale as 'en' | 'fi' | 'sv');
    setFacetsData(facetsData);
  }, [results, initialResults, filters, setFacetsData, locale]);

  return null;
};
